import React, { useState } from 'react';
import { Modal, Form, Input } from 'antd';
import './CustomerRegistrationModal.css';
import { useTranslation } from '../../context/LanguageContext';
import axios from '../../utils/axios';
import { toast } from 'react-hot-toast';

const CustomerRegistrationModal = ({ visible, onClose, onSuccess }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    const handleSubmit = async () => {
        try {
            setLoading(true);
            const values = await form.validateFields();
            
            const response = await axios.post('/customers', values);
            
            toast.success(t('cashier:customer.register.success'));
            form.resetFields();
            onSuccess(response.data.data);
            onClose();
        } catch (error) {
            console.error('Error registering customer:', error);
            toast.error(error.response?.data?.message || t('cashier:customer.register.error'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            className="customer-registration-modal"
            title={t('cashier:customer.register.title')}
            open={visible}
            onCancel={onClose}
            onOk={handleSubmit}
            confirmLoading={loading}
            okText={t('cashier:customer.register.submit')}
            cancelText={t('cashier:customer.register.cancel')}
            zIndex={2000}
        >
            <Form
                form={form}
                layout="vertical"
            >
                <Form.Item
                    name="name"
                    label={t('cashier:customer.form.name.label')}
                    rules={[{ required: true, message: t('cashier:customer.form.name.required') }]}
                >
                    <Input placeholder={t('cashier:customer.form.name.placeholder')} />
                </Form.Item>

                <Form.Item
                    name="phone"
                    label={t('cashier:customer.form.phone.label')}
                    rules={[{ required: true, message: t('cashier:customer.form.phone.required') }]}
                >
                    <Input placeholder={t('cashier:customer.form.phone.placeholder')} />
                </Form.Item>

                <Form.Item
                    name="address"
                    label={t('cashier:customer.form.address.label')}
                    rules={[{ required: true, message: t('cashier:customer.form.address.required') }]}
                >
                    <Input.TextArea rows={3} placeholder={t('cashier:customer.form.address.placeholder')} />
                </Form.Item>

                <Form.Item
                    name="notes"
                    label={t('cashier:customer.form.notes.label')}
                >
                    <Input.TextArea rows={2} placeholder={t('cashier:customer.form.notes.placeholder')} />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default CustomerRegistrationModal;
